import { Spin } from "antd";
import Cookies from "js-cookie";
import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  projectRoutes,
  dashboardRoutes,
  settingsRoute,
  admin,
  persistUserDetailState,
} from "./constants";
import { useCurrentUserContext } from "providers";
import { useRecoilState } from "recoil";
import {
  userDetailData,
  userDetailPopup,
  userListPagination,
  userListSearch,
} from "store/atom";
import { getCurrentEnviornment } from "utils/constants";

export function RequireAuth({
  children,
  setAuthenticated,
  authenticated,
}: any) {
  const myAuth = Cookies.get(`${getCurrentEnviornment()}_sessionToken`);
  const { pathname } = useLocation();
  const [, setUserDetail] = useRecoilState(userDetailData);
  const [, setPagination] = useRecoilState(userListPagination);
  const [, setUserSearch] = useRecoilState(userListSearch);
  const [, setDetailPopup] = useRecoilState(userDetailPopup);
  const navigate = useNavigate();

  const {
    user,
    saveUserData,
    refetch: refetchUser,
    data: userDataFromApi,
    error: userError,
    isLoading: userLoading,
  }: any = useCurrentUserContext();

  const NotFound: any = <h1 style={{ textAlign: "center" }}> 404 Not Found</h1>;

  useEffect(() => {
    if (!persistUserDetailState?.includes(pathname)) {
      setUserSearch("");
      setDetailPopup(false);
      setPagination({
        current: 1,
        pageSize: 100,
        totalRecords: 0,
      });
      setUserDetail({
        username: null,
        userEmail: null,
        userId: null,
      });
    }
  }, [pathname]);

  const authRoutesArray =
    user?.projects
      ?.map((state: any) => projectRoutes[state])
      ?.reduce((accumulator: any, currentValue: any) => {
        return accumulator?.concat(currentValue);
      }, []) || [];

  // console.table({ user: { authRoutesArray, projectRoutes, dashboardRoutes } });

  useEffect(() => {
    if (myAuth && user) {
      setAuthenticated(true);
    } else {
      setAuthenticated(false);
      saveUserData(null);
    }
  }, [user, myAuth]);

  useEffect(() => {
    if (!user) {
      setTimeout(() => {
        refetchUser();
      }, 10);
    }
  }, [user]);

  useEffect(() => {
    if (user?.role === "intern") {
      navigate("/m2c-golf-history");
    }
  }, [user]);

  useEffect(() => {
    if (userDataFromApi) {
      saveUserData(userDataFromApi);
    }
  }, [userDataFromApi]);

  if ((!myAuth || userError?.response?.status === 401) && !user) {
    return <Navigate to="/" state={{ path: pathname }} />;
  }

  if (!user || userLoading) {
    return (
      <Spin
        style={{ display: "flex", justifyContent: "center" }}
        spinning={true}
      ></Spin>
    );
  }

  // issue (don't need to be set here)
  // if (myAuth && user) {
  //   setAuthenticated(true);
  // }

  if (
    dashboardRoutes.includes(pathname) &&
    !authRoutesArray.includes(pathname)
  ) {
    return NotFound;
  }

  if (pathname === settingsRoute) {
    return user?.role === admin ? children : NotFound;
  }

  return children;
}
